import './home.css'
import MainHeader from '../../components/MainHeader'
import FAQs from '../../components/FAQs'
import { Link } from 'react-router-dom'

const Home = () => {
  return (
    <>
      <MainHeader/>

      <section className="home-classes">
        <div className="container">
          <div className="home-classes__grid">
            <div>
              <p className="home-classes__label">In Studio</p>
              <h2 className="home-classes__title">Friday classes</h2>
              <p className="home-classes__body">Join us in person at Soley Massage and Wellness every Friday.</p>
              <p className="home-classes__detail">
                Soley Massage and Wellness<br/>
                St Petersburg, FL<br/>
                <br/>
                Friday at 6pm
              </p>
            </div>
            <div>
              <p className="home-classes__label">Online</p>
              <h2 className="home-classes__title">Weekend classes</h2>
              <p className="home-classes__body">The weekend classes that support your home practice, wherever you are.</p>
              <p className="home-classes__detail">
                Saturday at 8:15am<br/>
                Sunday at 10am
              </p>
            </div>
          </div>
        </div>
      </section>

      <div className="home-teaser">
        <div className="container">
          <div className="home-teaser__inner">
            <div className="home-teaser__dot"></div>
            <p className="home-teaser__text">Exciting news coming soon — watch this space.</p>
          </div>
        </div>
      </div>

      <section className="home-packages">
        <div className="container">
          <div className="home-packages__header">
            <p className="home-packages__eyebrow">Pricing</p>
            <h2 className="home-packages__title">Packages &amp; memberships</h2>
            <p className="home-packages__sub">Choose the option that fits your practice.</p>
          </div>
          <div className="home-packages__grid">
            <div className="home-pkg-card">
              <p className="home-pkg-card__label">Most popular</p>
              <h3 className="home-pkg-card__title">Class passes</h3>
              <p className="home-pkg-card__body">4 or 8 classes, valid for 60–90 days. In-person and online.</p>
              <p className="home-pkg-card__price">from $84</p>
              <Link to="/pricing" className="home-pkg-card__link">View passes →</Link>
            </div>
            <div className="home-pkg-card home-pkg-card--dark">
              <p className="home-pkg-card__label">Committed practice</p>
              <h3 className="home-pkg-card__title">Memberships</h3>
              <p className="home-pkg-card__body">2× per week or unlimited. Monthly rolling, no contract.</p>
              <p className="home-pkg-card__price">from $129/mo</p>
              <Link to="/pricing" className="home-pkg-card__link">View memberships →</Link>
            </div>
            <div className="home-pkg-card">
              <p className="home-pkg-card__label">Flexible</p>
              <h3 className="home-pkg-card__title">Drop-in</h3>
              <p className="home-pkg-card__body">No commitment. Pay for a single class any time.</p>
              <p className="home-pkg-card__price">$26</p>
              <Link to="/" className="home-pkg-card__link">Book now →</Link>
            </div>
            <div className="home-pkg-card">
              <p className="home-pkg-card__label">Personal</p>
              <h3 className="home-pkg-card__title">Private classes</h3>
              <p className="home-pkg-card__body">One-to-one instruction tailored to your body and goals.</p>
              <p className="home-pkg-card__price">from $129</p>
              <a href="mailto:info@iy-sp.com" className="home-pkg-card__link">Enquire →</a>
            </div>
          </div>
        </div>
      </section>

      <div className="calendar-embed">
        <iframe
          src="https://florium.studio/iy-sp/embed"
          title="Class Booking"
          allowpaymentrequest="true"
        />
      </div>

      <FAQs/>
    </>
  )
}

export default Home
